import { render } from "./SelectCharView.vue?vue&type=template&id=48ca1540&scoped=true"
import script from "./SelectCharView.vue?vue&type=script&lang=js"
export * from "./SelectCharView.vue?vue&type=script&lang=js"

import "./SelectCharView.vue?vue&type=style&index=0&id=48ca1540&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48ca1540"

export default script